module.exports = __webpack_public_path__ + "img/115.fe674ff7.jpg";